import { HOST } from "../api/constants";

const API_UPLOAD_PATH_PREFIXES = ["/media/site-page/", "/media/site-page-video/"];

/**
 * Resolves URLs stored in site CMS (`home.*` images, hero videos, etc.) for use in `<img>`, `<video>`, CSS `url(...)`.
 * - Absolute http(s) and `data:` URLs are unchanged.
 * - Uploaded files served by Spring Boot (`/media/site-page/...`, `/media/site-page-video/...`) use `HOST`.
 * - Everything else is returned as-is (e.g. `/images/cms-defaults/...`, `/videos/cms-defaults/...` from `public/`).
 */
export function resolveCmsAssetUrl(url) {
  if (url == null || url === "") return "";
  const s = String(url).trim();
  if (/^(https?:|data:)/i.test(s)) return s;
  const base = (HOST || "").replace(/\/$/, "");
  if (API_UPLOAD_PATH_PREFIXES.some((prefix) => s.startsWith(prefix))) {
    return base + s;
  }
  return s;
}
